export const shallowCopy = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return [...value] as T;
  }
  if (value instanceof Map) {
    return new Map(value) as T;
  }
  if (value instanceof Set) {
    return new Set(value) as T;
  }
  if (typeof value === 'object' && value !== null) {
    return { ...value };
  }
  return value;
};
